<template>
	<el-dialog title="" :visible.sync="examVisible" width="30%" center :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
    <span>测试须知：{{ exam.examDescription }}</span>
    <div class="content">
      <span>测试机会：{{ exam.remainingExamTimes }}次</span>
      <span>时间：{{ exam.examDuration }}分钟</span>
      <span>题目：{{ exam.questionNum }}题</span>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="returnCourseList">重新学习</el-button>
      <el-button type="primary" @click="beginExam">开始测试</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      examVisible: false,
      exam: {
        examDescription: null, //测试须知
        examDuration: null, //测试时间
        questionNum: null, //测试题目
        remainingExamTimes: null, //测试机会
        passScore: null //通关分数
      }
    }
  },
  props: ['courseId', 'visible', 'tabMajorId', 'majorId', 'type', 'isListPage', 'parent', 'id'],
  watch: {
  	visible: function() {
  		this.examVisible = this.visible;
  		this.getExamDetail(this.courseId);
  	}
  },
  created() {

  },
  mounted() {

  },
  methods: {
    //获取考试弹出层信息
    getExamDetail(courseId) {
      this.$http.post(API_ROOT.college + '/examining/getExamDetail', {'courseId': courseId}).then(res=> {
        var result = res.data;
        if(result.success) {
          this.exam.examDescription = result.data.examDescription;
          this.exam.examDuration = result.data.examDuration;
          this.exam.questionNum = result.data.questionNum;
          this.exam.remainingExamTimes = result.data.remainingExamTimes;
          this.exam.passScore = result.data.passScore;
        }else {
          this.$alert(result.msg);
        }
      },res=> {
        this.$alert("AJAX请求接口异常（/examining/getExamDetail）！");
      })
    },
    returnCourseList() {
    	this.$emit('callback', false);
    	if(!this.isListPage) {
            window.location.href = '/tjkStudy/train/childCourseList?id='+this.id+'&type='+this.type+'&majorId='+this.majorId+'&tabMajorId='+this.tabMajorId;
    	}
    },
    //开始考试
    beginExam() {
      window.location.href = '/tjkStudy/train/examDetail?courseId='+this.courseId+'&majorId='+this.majorId+'&tabMajorId='+this.tabMajorId+'&type='+this.type+'&score='+this.exam.passScore+'&parent='+this.parent+'&id='+this.id;
    },
  } 
}
</script>

<style lang="less" scoped>
	.content {
		padding-top: 10px;
		> span {
			padding-right: 20px;
		}
	}
</style>


// WEBPACK FOOTER //
// ./src/page/train/examDialog.vue